import React from 'react';
import { motion } from 'framer-motion';
export function AmbientBackground() {
  return <div className="fixed inset-0 z-[-1] overflow-hidden bg-background" data-id="element-18">
      <div className="absolute inset-0 noise-bg opacity-[0.06] mix-blend-overlay" data-id="element-19"></div>

      <motion.div animate={{
      scale: [1, 1.1, 1],
      opacity: [0.2, 0.35, 0.2]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -top-[20%] -left-[10%] w-[80vw] md:w-[50vw] h-[80vw] md:h-[50vw] rounded-full bg-electric/30 blur-[80px] md:blur-[120px]" data-id="element-20" />

      <motion.div animate={{
      scale: [1, 1.15, 1],
      opacity: [0.15, 0.3, 0.15]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute -bottom-[20%] -right-[10%] w-[90vw] md:w-[60vw] h-[90vw] md:h-[60vw] rounded-full bg-neon/20 blur-[100px] md:blur-[150px]" data-id="element-21" />

      <motion.div animate={{
      opacity: [0.1, 0.25, 0.1]
    }} transition={{
      duration: 14,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 4
    }} className="hidden md:block absolute top-[40%] left-[40%] w-[40vw] h-[40vw] rounded-full bg-cyan/20 blur-[130px]" data-id="element-22" />
    </div>;
}